import styles from "../styles/Reports.module.scss";
import React from "react";

export function FormItem(props) {
  return (
    <div className={props.className ?? styles.formItem}>{props.children}</div>
  );
}
